import { create } from 'zustand';

interface Category {
  id: string;
  name: string;
  icon: string;
  color: string;
  sortOrder: number;
}

interface AppState {
  // カテゴリ
  categories: Category[];
  setCategories: (categories: Category[]) => void;

  // 現在選択中の年月
  currentYearMonth: string;
  setCurrentYearMonth: (yearMonth: string) => void;

  // UI State
  isRefreshing: boolean;
  setRefreshing: (isRefreshing: boolean) => void;

  // Toast
  toast: { message: string; type: 'success' | 'error' | 'info' } | null;
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void;
  hideToast: () => void;
}

// 今月の年月を取得
const getCurrentYearMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

export const useAppStore = create<AppState>((set) => ({
  // カテゴリ
  categories: [],
  setCategories: (categories) => set({ categories }),

  // 現在選択中の年月
  currentYearMonth: getCurrentYearMonth(),
  setCurrentYearMonth: (yearMonth) => set({ currentYearMonth: yearMonth }),

  // UI State
  isRefreshing: false,
  setRefreshing: (isRefreshing) => set({ isRefreshing }),

  // Toast
  toast: null,
  showToast: (message, type = 'info') => {
    set({ toast: { message, type } });
    setTimeout(() => {
      set({ toast: null });
    }, 3000);
  },
  hideToast: () => set({ toast: null }),
}));
